import './package-accommodation.scss';

import { Outlet } from "react-router-dom";

import { FilterPackageAccommodationProvider } from "./filter-package-accommodation/filter-package-accommodation.context";

export function PackageAccommodation() {
  return (
    <div id="ShellPackageAccommodation" className="package-accommodation">
       <FilterPackageAccommodationProvider>
        <Outlet />
      </FilterPackageAccommodationProvider>
    </div>
  );
}

export default PackageAccommodation;
